

























































































































































































































import DsModal from '@/shared/modal/ds-modal.vue';
import { Account } from '@/shared/model/scrap-agent.model';
import { PropType } from 'vue';
import { opts } from '@/entities/scrap-agent/scrap-agent-common/common';

export default {
  components: { DsModal },
  props: {
    open: Boolean,
    account: Object as PropType<Account>,
  },
  data() {
    return {
      showModal: this.open,
      options: opts.blog_option,
      selectedOptions: [] as { dataSourceType: string }[],
    };
  },
  methods: {
    handleCloseModal() {
      this.$emit('modal:close');
    },
    handleSelect(event: Event) {
      const selectedValue = (event.target as HTMLSelectElement).value;
      const selectedOption = this.options.find(opt => opt.dataSourceType === selectedValue);

      if (selectedOption && !this.selectedOptions.some(opt => opt.dataSourceType === selectedOption.dataSourceType)) {
        this.selectedOptions.push(selectedOption);
      }
    },
    removeOption(index: number) {
      this.selectedOptions.splice(index, 1);
    },
    onSubmit() {
      this.$emit('modal:ok', this.selectedOptions);
    },
  },
  watch: {
    open(value) {
      this.showModal = value;
    },
    account: {
      handler(value) {
        this.selectedOptions = this.account.dataSource ?? [];
      },
      immediate: true,
      deep: true,
    },
    showModal(value) {
      this.$emit('update:open', value);
    },
  },
};
